













import {mixins}                     from 'vue-class-component';
import {Component}                  from 'vue-property-decorator';
import MainMixin                    from '@/mixins/Main';
import LeagueSectionMixin           from '@/mixins/LeagueSection';
import TableContainerContainerMixin from '@/mixins/TableContainerContainer';
import TableContainer               from '@/components/table/TableContainer.vue';

@Component({
    components: {
        TableContainer
    },
    name: `LeaguePrizes`
})
export default class LeaguePrizes extends mixins(MainMixin, LeagueSectionMixin, TableContainerContainerMixin)
{
    public rowsSortCompareFn([, prizeA]: [string, LeaguePrizeValue], [, prizeB]: [string, LeaguePrizeValue]): number
    {
        return prizeB.money - prizeA.money;
    }

    public tableName = `leaguePrizes`;
    public columns = {
        money: {
            fixed: 0,
            order: 2,
            type: `currency`
        },
        place: {
            order: 0,
            type: `index`
        }
    };
    public entrance: number = parseFloat(process.env.VUE_APP_FM_LEAGUE_REGISTRATION_MONEY);
    public thead = true;

    public get nestedValues(): string[]
    {
        return this.$store.state.leaguePrizes.nestedProps.map((nestedProp) =>
        {
            return this[nestedProp];
        });
    }

    public get playersRegistered(): number
    {
        const pool: number = Object.values(this.rows).reduce((a, prize) =>
        {
            return a + prize.money;
        }, 0);

        if (this.seasonId === 1)
        {
            switch (this.divisionId)
            {
                case 13:
                    return 6;
                case 14:
                    return 4;
                case 15:
                    return 3;
            }
        }

        return Math.round(pool / 7);
    }

    public get rows()
    {
        return this.rowsGet(`leaguePrizes`);
    }
}
